// extracted by mini-css-extract-plugin
export default {"rightSideContainer":"firstStep_rightSideContainer__JqUWb"};